/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

const I18N_BASE_PATH = 'pages.private.KYBCompany.pages.companyDetails.subPages.records';

const RecordBody = ({ loading, record, onViewRecord }) => {
  const { t } = useTranslation();

  return (
    <div className="flex space-between center pdd-vertical-20 text-dark page-break-inside-avoid">
      <div>
        <p className="no-mrg text-bold">{t(`${I18N_BASE_PATH}.source`, 'Source')}</p>
        <p className="no-mrg mrg-top-5">{record.source.name}</p>
      </div>
      <div className="flex-column center">
        <Button
          type="primary"
          block
          className="no-mrg company-print-no-render"
          onClick={onViewRecord}
          loading={loading}
          style={{ minWidth: 200 }}
        >
          {t(`${I18N_BASE_PATH}.viewRecord`, 'View record')}
        </Button>
        {!record.saved && !loading && (
          <span className="font-size-12 mrg-top-10 charge-text company-print-no-render">
            {t(`${I18N_BASE_PATH}.charge`, 'This will incur an additional charge')}
          </span>
        )}
      </div>
    </div>
  );
};

export default RecordBody;

RecordBody.propTypes = {
  record: PropTypes.any.isRequired,
  loading: PropTypes.bool.isRequired,
  onViewRecord: PropTypes.func.isRequired,
};
